import { render, staticRenderFns } from "./IndividualProfileSettings.vue?vue&type=template&id=000b8a44&scoped=true"
import script from "./IndividualProfileSettings.vue?vue&type=script&lang=js"
export * from "./IndividualProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./IndividualProfileSettings.vue?vue&type=style&index=0&id=000b8a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b8a44",
  null
  
)

export default component.exports